import { currencyNumberFormat } from '../../../utilities/number-format';

import { InvoiceDetails, InvoiceDetailsPayment } from '../types/invoices-details';
import { LineItemNextPayer } from '../types/invoices-details';

export const getPaymentAmountContent = (lineItem: {
  amount: number;
  nextPayer: LineItemNextPayer;
}) => {
  const { amount, nextPayer } = lineItem;

  if (!nextPayer || nextPayer === 'PATIENT') return currencyNumberFormat(amount);
  else return 'Pending with Insurance';
};

const FEE_DISCOUNT_LABELS: Record<string, string> = {
  'late cancel': 'Late cancellation fee adjustment',
  'no show': 'No-show fee adjustment'
};

const FEE_INVOICE_LABELS: Record<string, string> = {
  'late cancel': 'Late cancellation fee',
  'no show': 'No-show fee'
};

const PAYMENT_REASON_LABELS: Record<string, string> = {
  late_cancel: 'Late cancellation',
  no_show: 'No-show'
};

const normalizeReason = (reason: string) => reason.trim().toLowerCase();

export const getDiscountLabel = (discount: NonNullable<InvoiceDetails['discount']>) => {
  const feeDiscountLabel = FEE_DISCOUNT_LABELS[normalizeReason(discount.reason)];

  return feeDiscountLabel ?? `Discount for ${discount.reason}`;
};

export const shouldRenderDiscountRow = (discount: NonNullable<InvoiceDetails['discount']>) =>
  !(discount.amount === 0 && normalizeReason(discount.reason) in FEE_DISCOUNT_LABELS);

export const getKindbodyRateLabel = ({
  discount,
  kindbodyRateAmount,
  lineItemsTotalAmount
}: Pick<InvoiceDetails, 'discount' | 'kindbodyRateAmount' | 'lineItemsTotalAmount'>) => {
  const reason = discount ? normalizeReason(discount.reason) : null;

  if (reason && lineItemsTotalAmount === 0 && kindbodyRateAmount > 0) {
    return FEE_INVOICE_LABELS[reason] ?? 'Kindbody Rate (Patient Total)';
  }

  return 'Kindbody Rate (Patient Total)';
};

export const getPaymentLabel = (
  payment: Pick<InvoiceDetailsPayment, 'reason'>,
  paymentType: string
) => {
  if (!payment.reason) return paymentType;

  const reasonLabel = PAYMENT_REASON_LABELS[normalizeReason(payment.reason)];

  return reasonLabel
    ? `${reasonLabel} ${paymentType.toLowerCase()}`
    : `${payment.reason} ${paymentType}`;
};
